import { render } from "./UnsubRenderer.vue?vue&type=template&id=a10d9f32"
import script from "./UnsubRenderer.vue?vue&type=script&lang=ts"
export * from "./UnsubRenderer.vue?vue&type=script&lang=ts"
script.render = render

export default script